<!--Copy right - © 2024 tecera gmbh-->
<script>
    import {
        is_authenticated,
        check_if_authenticated,
        user_permissions,
        user_role,
        rerout_user,
    } from "../scripts/auth.js";
    import NavBar from "../components/NavBar.svelte";
    import Footer from "../components/Footer.svelte";
    import DeviceTabelle from "../components/DeviceTabelle.svelte";
    import {
        selected_device,
        user_list,
        toast_message,
        customer_list,
    } from "../stores.js";
    import { BASE_API_URL } from "../config.js";
    import { onDestroy, onMount, tick } from "svelte";
    import { get_user_list, get_customer_list } from "../scripts/data.js";
    import DeviceSearchField from "../components/DeviceSearchField.svelte";

    onMount(async () => {
        $selected_device = null; // need to set this to null incase user comes from different tab
        await check_if_authenticated(); // waiting for auth before proceeding
        if (!$user_role["rank"] || $user_role["rank"] > 2) {
            rerout_user();
            return;
        }
        get_customer_list();
        loading = get_devices();
    });

    let devices = [],
        devices_copy = [];
    let search_input = "";
    let user_box;
    let is_button_disabled = false;
    let loading;

    async function get_devices() {
        let url_extension = `/device_management/`;
        let request_url = BASE_API_URL + url_extension;
        try {
            const response = await fetch(request_url, {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            devices = data;
            return true;
        } catch (error) {
            return false;
        }
    }

    $: {
        devices_copy = JSON.parse(JSON.stringify(devices)); // deep copy of devices so we can use save/reset functionality
    }

    //TODO: Check if needed
    async function check_table_overflow() {
        // check wether the table gets a scrollbar, so dropdowns are not cut off
        await tick();
        if (user_box && user_box.scrollHeight > user_box.clientHeight) {
            user_box.style.overflow = "auto";
        } else if (user_box) {
            user_box.style.overflow = "visible";
        }
    }

    //TODO: Check if needed
    $: {
        // check overflow on table changes
        if (devices_copy) {
            check_table_overflow();
        }
    }

    function reset_devices_copy() {
        // reset user_list_copy to original state
        devices_copy = JSON.parse(JSON.stringify(devices));
    }

    //TODO: update
    async function save_devices() {
        timeout_button();
        // save changes and make the API call
        function get_changed_entries() {
            // determine changed entries, to not send all data every time
            const changed_entries = [];
            
            for (let i = 0; i < devices.length; i++) {
                if (devices_copy[i] === null) { // deleted entry
                    changed_entries.push({
                        is_deleted: true,
                        device_data: {
                            id: devices[i].id,
                        },
                    });
                } else if (
                   ( JSON.stringify(devices[i].customer.id) !==
                    JSON.stringify(devices_copy[i].customer.id)) || 
                    ( JSON.stringify(devices[i].device_customers) !==
                    JSON.stringify(devices_copy[i].device_customers))
                ) {
                    changed_entries.push({
                        device_data: {
                            id: devices_copy[i].id,
                            customer: devices_copy[i].customer.id,
                            device_customers: devices_copy[i].device_customers,
                        },

                    });
                }
            }
            
            return changed_entries;
        }
        let changed_entries = get_changed_entries();
        if (changed_entries.length === 0) {
            $toast_message = " Änderungen gespeichert.";
            return;
        }
        let url_extension = `/device_management/bulk-update/`;
        let request_url = BASE_API_URL + url_extension;
        try {
            const response = await fetch(request_url, {
                method: "PATCH",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(changed_entries),
            });
            if (!response.ok) {
                return false;
            }
            $toast_message = " Änderungen gespeichert.";
            get_devices();
            return true;
        } catch (error) {
            return false;
        }
    }


    function timeout_button() {
        is_button_disabled = true;
        setTimeout(() => {
            is_button_disabled = false;
        }, 500);
    }
</script>

<svelte:head>
    <title>Mapview - Geräte</title>
</svelte:head>

{#if $is_authenticated && $user_role["rank"] <= 2}
    <div class="container-fluid">
        <div class="row">
            <!-- Main Content -->
            <main class="col-12 ml-sm-auto px-md-4">
                <NavBar headline="Geräteverwaltung" />

                <div class="row">
                    <!-- Linke Seite -->
                    <div
                        class="col-12 content_main"
                        style="display:flex;flex-direction:column;justify-content:flex-start;"
                    >
                        <!-- Tabelle -->
                        <div
                            class="row mt-4"
                            style="flex: 1 1 40%;overflow:hidden;"
                        >
                            <div class="col-12 full">
                                <div style="display: flex; justify-content:flex-start;align-items:center;max-height:5%;">
                                    <div style="width:40%;">
                                    <DeviceSearchField bind:device_search_input={search_input} placeholder="Suche DevEUI/Zählernummer" />
                                </div>
                                </div>
                                <div
                                    class="user_box2"
                                    style="overflow:auto;height:95%"
                                    bind:this={user_box}
                                >
                                    <DeviceTabelle device_list={devices_copy} bind:search_input bind:loading/>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3" style="flex: 0 0 4%;">
                            <!-- Buttons -->
                            <div class="btn-toolbar-inverse pb-1 ml-auto">
                                <div class="btn-distance">
                                    <button
                                        class="btn btn-secondary"
                                        type="button"
                                        on:click={() => reset_devices_copy()}
                                        >Zurücksetzen</button
                                    >
                                </div>

                                <div class="btn-distance">
                                    <button
                                        class="btn btn-primary"
                                        type="button"
                                        disabled={is_button_disabled}
                                        on:click={() => {
                                            save_devices();
                                        }}>Änderungen speichern</button
                                    >
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div
                        class="col-12 col-lg-4 col-xl-3 content_main content_main_side"
                    >
                        <div class="row pt-4 full">
                            <div class="col-12 full">
                                <div class="display_box side-menu">
                                    <p class="p-kachel">?????</p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </main>
        </div>
    </div>
    <Footer />
{/if}
